import { render } from "./Entry.vue?vue&type=template&id=5b8ac0a0&scoped=true"
import script from "./Entry.vue?vue&type=script&lang=js"
export * from "./Entry.vue?vue&type=script&lang=js"

import "./Entry.vue?vue&type=style&index=0&id=5b8ac0a0&scoped=scoped&lang=css"

import exportComponent from "D:\\CODE\\clpgaAppDevnew\\clpga_html\\f_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b8ac0a0"]])

export default __exports__